<ng-container [ngSwitch]="field.name">
    <ng-container *ngSwitchCase="'fontFamilyPrim'">
        <div class="input-cell">
            <!-- <div class="input-wrapper-row">
                <div class="input-label">Current:</div>
                <div class="current-value">{{primaryFontFamily}}</div>
            </div> -->
            <div class="input-wrapper-row">
               <div class="sample" [ngStyle]="{'font-family': primaryFontFamily}">The Quick Brown Fox Jumps Over The Lazy Dog</div> 
            </div>
            <nb-select size="tiny" fullWidth [(ngModel)]="primaryFontFamily" optionsPanelClass="font-select-list" (selectedChange)="onFontSelect({type:'primary',value:$event})">
                <nb-option *ngFor="let font of fontFamilies" 
                [value]="font.value" 
                [ngStyle]="{'font-family': font.value}"
                (mouseover)="onMouseOver({type:'primary',font:font.value})">{{font.name}}</nb-option>
            </nb-select>
        </div>
    </ng-container>
    <ng-container *ngSwitchCase="'fontFamilySec'">
        <div class="input-cell">
            <!-- <div class="input-wrapper-row">
                <div class="input-label">Current:</div>
                <div class="current-value">{{secondaryFontFamily}}</div>
            </div> -->
            <div class="input-wrapper-row">
                <div class="h6 sample" [ngStyle]="{'font-family': secondaryFontFamily}">The Quick Brown Fox Jumps Over The Lazy Dog</div>
            </div>
            <nb-select size="tiny" fullWidth [(ngModel)]="secondaryFontFamily" optionsPanelClass="font-select-list" (selectedChange)="onFontSelect({type:'secondary',value:$event})">
                <nb-option 
                *ngFor="let font of fontFamilies" 
                [value]="font.value" [ngStyle]="{'font-family': font.value}"
                (mouseover)="onMouseOver({type:'secondary',font:font.value})">{{font.name}}</nb-option>
            </nb-select>
        </div>        
    </ng-container>
</ng-container>
